<template>
    <div style="padding: 10px;">
        <!---el-form :label-width="{ '125px' : smScreen , '220px' : !smScreen}"--->
        <el-form :label-width="formLabelWidth">
            <el-form-item prop="companyName" ref="companyName">
                <div slot="label" class="form-item-label" v-t="'message.item_companyName'"></div>
                <el-input id="companyName" size="large" type="text"
                          v-model="inputForm.companyName.value" :placeholder="$t('message.item_companyName_sample')"
                          @compositionstart.native="compositionStart($event.target.id)" @compositionend.native="compositionEnd($event.target.id)" @input.native="inputCheck($event.target.id)"
                          clearable @clear="inputCheckAll()"/>
            </el-form-item>
            <el-form-item prop="companyNameKana" ref="companyNameKana">
                <div slot="label" class="form-item-label" v-t="'message.item_companyNameKana'"></div>
                <el-input id="companyNameKana" size="large" type="text"
                          v-model="inputForm.companyNameKana.value" :placeholder="$t('message.item_companyNameKana_sample')"
                          @compositionstart.native="compositionStart($event.target.id)" @compositionend.native="compositionEnd($event.target.id)" @input.native="inputCheck($event.target.id)"
                          clearable @clear="inputCheckAll()"/>
            </el-form-item>
            <table style="border-spacing: 0px;">
                <tr>
                    <td width="45%">
                        <el-form-item prop="representativeLastName" ref="representativeLastName">
                            <div slot="label" class="form-item-label" v-t="'message.item_representative_lastName'"></div>
                            <el-input id="representativeLastName" size="large" type="text"
                                      v-model="inputForm.representativeLastName.value" :placeholder="$t('message.item_lastName_sample1')"
                                      @compositionstart.native="compositionStart($event.target.id)" @compositionend.native="compositionEnd($event.target.id)" @input.native="inputCheck($event.target.id)"
                                      clearable @clear="inputCheckAll()"/>
                        </el-form-item>
                    </td>
                    <td width="10%">&nbsp;</td>
                    <td width="45%">
                        <el-form-item prop="representativeFirstName" ref="representativeFirstName">
                            <div slot="label" class="form-item-label" v-t="'message.item_representative_firstName'"></div>
                            <el-input id="representativeFirstName" size="large" type="text"
                                      v-model="inputForm.representativeFirstName.value" :placeholder="$t('message.item_firstName_sample1')"
                                      @compositionstart.native="compositionStart($event.target.id)" @compositionend.native="compositionEnd($event.target.id)" @input.native="inputCheck($event.target.id)"
                                      clearable @clear="inputCheckAll()"/>
                        </el-form-item>
                    </td>
                </tr>
                <tr>
                    <td width="45%">
                        <el-form-item prop="representativeLastNameKana" ref="representativeLastNameKana">
                            <div slot="label" class="form-item-label" v-t="'message.item_representative_lastName_kana'"></div>
                            <el-input id="representativeLastNameKana" size="large" type="text"
                                      v-model="inputForm.representativeLastNameKana.value" :placeholder="$t('message.item_lastNameKana_sample1')"
                                      @compositionstart.native="compositionStart($event.target.id)" @compositionend.native="compositionEnd($event.target.id)" @input.native="inputCheck($event.target.id)"
                                      clearable @clear="inputCheckAll()"/>
                        </el-form-item>
                    </td>
                    <td width="10%">&nbsp;</td>
                    <td width="45%">
                        <el-form-item prop="representativeFirstNameKana" ref="representativeFirstNameKana">
                            <div slot="label" class="form-item-label" v-t="'message.item_representative_firstName_kana'"></div>
                            <el-input id="representativeFirstNameKana" size="large" type="text"
                                      v-model="inputForm.representativeFirstNameKana.value" :placeholder="$t('message.item_firstNameKana_sample1')"
                                      @compositionstart.native="compositionStart($event.target.id)" @compositionend.native="compositionEnd($event.target.id)" @input.native="inputCheck($event.target.id)"
                                      clearable @clear="inputCheckAll()"/>
                        </el-form-item>
                    </td>
                </tr>
            </table>
            <el-form-item prop="employees" ref="employees">
                <div slot="label" class="form-item-label" v-t="'message.item_number_of_employees'"></div>
                <el-input id="employees" size="large" type="text"
                          v-model="inputForm.employees.value" placeholder="100"
                          @compositionstart.native="compositionStart($event.target.id)" @compositionend.native="compositionEnd($event.target.id)" @input.native="inputCheck($event.target.id)"
                          clearable @clear="inputCheckAll()"/>
            </el-form-item>
            <table style="border-spacing: 0px;">
                <tr>
                    <td width="45%">
                        <el-form-item prop="clerkLastName" ref="clerkLastName">
                            <div slot="label" class="form-item-label" v-t="'message.item_clerk_lastName'"></div>
                            <el-input id="clerkLastName" size="large" type="text"
                                      v-model="inputForm.clerkLastName.value" :placeholder="$t('message.item_lastName_sample2')"
                                      @compositionstart.native="compositionStart($event.target.id)" @compositionend.native="compositionEnd($event.target.id)" @input.native="inputCheck($event.target.id)"
                                      clearable @clear="inputCheckAll()"/>
                        </el-form-item>
                    </td>
                    <td width="10%">&nbsp;</td>
                    <td width="45%">
                        <el-form-item prop="clerkFirstName" ref="clerkFirstName">
                            <div slot="label" class="form-item-label" v-t="'message.item_clerk_firstName'"></div>
                            <el-input id="clerkFirstName" size="large" type="text"
                                      v-model="inputForm.clerkFirstName.value" :placeholder="$t('message.item_firstName_sample2')"
                                      @compositionstart.native="compositionStart($event.target.id)" @compositionend.native="compositionEnd($event.target.id)" @input.native="inputCheck($event.target.id)"
                                      clearable @clear="inputCheckAll()"/>
                        </el-form-item>
                    </td>
                </tr>
                <tr>
                    <td width="45%">
                        <el-form-item prop="clerkLastNameKana" ref="clerkLastNameKana">
                            <div slot="label" class="form-item-label" v-t="'message.item_clerk_lastName_kana'"></div>
                            <el-input id="clerkLastNameKana" size="large" type="text"
                                      v-model="inputForm.clerkLastNameKana.value" :placeholder="$t('message.item_lastNameKana_sample2')"
                                      @compositionstart.native="compositionStart($event.target.id)" @compositionend.native="compositionEnd($event.target.id)" @input.native="inputCheck($event.target.id)"
                                      clearable @clear="inputCheckAll()"/>
                        </el-form-item>
                    </td>
                    <td width="10%">&nbsp;</td>
                    <td width="45%">
                        <el-form-item prop="clerkFirstNameKana" ref="clerkFirstNameKana">
                            <div slot="label" class="form-item-label" v-t="'message.item_clerk_firstName_kana'"></div>
                            <el-input id="clerkFirstNameKana" size="large" type="text"
                                      v-model="inputForm.clerkFirstNameKana.value" :placeholder="$t('message.item_firstNameKana_sample2')"
                                      @compositionstart.native="compositionStart($event.target.id)" @compositionend.native="compositionEnd($event.target.id)" @input.native="inputCheck($event.target.id)"
                                      clearable @clear="inputCheckAll()"/>
                        </el-form-item>
                    </td>
                </tr>
            </table>
            <el-form-item prop="departmentName" ref="departmentName">
                <div slot="label" class="form-item-label" v-t="'message.item_departmentName'"></div>
                <el-input id="departmentName" size="large" type="text"
                          v-model="inputForm.departmentName.value" :placeholder="$t('message.item_departmentName_sample')"
                          @compositionstart.native="compositionStart($event.target.id)" @compositionend.native="compositionEnd($event.target.id)" @input.native="inputCheck($event.target.id)"
                          clearable @clear="inputCheckAll()"/>
            </el-form-item>
            <table style="border-spacing: 0px;">
                <tr>
                    <td width="45%">
                        <el-form-item prop="zip" ref="zip">
                            <div slot="label" class="form-item-label" v-t="'message.item_zip'"></div>
                            <el-input id="zip" type="number"
                                      v-model="inputForm.zip.value" :placeholder="1500002"
                                      @compositionstart.native="compositionStart($event.target.id)" @compositionend.native="compositionEnd($event.target.id)" @input.native="inputCheck($event.target.id)"
                                      clearable @clear="inputCheckAll()"/>
                        </el-form-item>
                    </td>
                    <td width="10%">&nbsp;</td>
                    <td width="45%">
                        <el-form-item prop="pref" ref="pref">
                            <div slot="label" class="form-item-label" v-t="'message.item_pref'"></div>
                            <el-select v-model="inputForm.pref.value"style="margin-left=15px" :placeholder="$t('message.item_pref_sample')" @change="handleChangePref()">
                                <el-option v-for="pref in prefList" :key="pref" :label="pref" :value="pref"></el-option>
                            </el-select>
                        </el-form-item>
                    </td>
                </tr>

                <tr>
                    <td width="45%">
                        <el-form-item prop="city" ref="city">
                            <div slot="label" class="form-item-label" v-t="'message.item_city'"></div>
                            <el-input id="city" type="text"
                                      v-model="inputForm.city.value" :placeholder="$t('message.item_city_sample')"
                                      @compositionstart.native="compositionStart($event.target.id)" @compositionend.native="compositionEnd($event.target.id)" @input.native="inputCheck($event.target.id)"
                                      clearable @clear="inputCheckAll()"/>
                        </el-form-item>
                    </td>
                    <td width="10%">&nbsp;</td>
                    <td width="45%">
                        <el-form-item prop="town" ref="town">
                            <div slot="label" class="form-item-label" v-t="'message.item_town'"></div>
                            <el-input id="town" type="text"
                                      v-model="inputForm.town.value" :placeholder="$t('message.item_town_sample')"
                                      @compositionstart.native="compositionStart($event.target.id)" @compositionend.native="compositionEnd($event.target.id)" @input.native="inputCheck($event.target.id)"
                                      clearable @clear="inputCheckAll()"/>
                        </el-form-item>
                    </td>
                </tr>
            </table>
            <el-form-item prop="street" ref="street">
                <div slot="label" class="form-item-label" v-t="'message.item_address'"></div>
                <el-input id="street" size="large" type="text"
                          v-model="inputForm.street.value" :placeholder="$t('message.item_address_sample')"
                          @compositionstart.native="compositionStart($event.target.id)" @compositionend.native="compositionEnd($event.target.id)" @input.native="inputCheck($event.target.id)"
                          clearable @clear="inputCheckAll()"/>
            </el-form-item>
            <el-form-item prop="phoneNumber" ref="phoneNumber">
                <div slot="label" class="form-item-label" v-t="'message.item_phoneNumber'"></div>
                <span v-if="smScreen"><br></span>
                <table style="border-spacing: 0px;">
                    <tr>
                        <td width="30%">
                            <el-input id="phoneNumber1" type="text"
                                      v-model="inputForm.phoneNumber1.value" placeholder="0123"
                                      @compositionstart.native="compositionStart($event.target.id)" @compositionend.native="compositionEnd($event.target.id)" @input.native="inputCheck($event.target.id)"
                                      clearable @clear="inputCheckAll()"/>
                        </td>
                        <td width="5%" style="text-align: center">-</td>
                        <td width="30%">
                            <el-input id="phoneNumber2" type="text"
                                      v-model="inputForm.phoneNumber2.value" placeholder="456"
                                      @compositionstart.native="compositionStart($event.target.id)" @compositionend.native="compositionEnd($event.target.id)" @input.native="inputCheck($event.target.id)"
                                      clearable @clear="inputCheckAll()"/>
                        </td>
                        <td width="5%" style="text-align: center">-</td>
                        <td width="30%">
                            <el-input id="phoneNumber3" type="text"
                                      v-model="inputForm.phoneNumber3.value" placeholder="7890"
                                      @compositionstart.native="compositionStart($event.target.id)" @compositionend.native="compositionEnd($event.target.id)" @input.native="inputCheck($event.target.id)"
                                      clearable @clear="inputCheckAll()"/>
                        </td>
                    </tr>
                </table>
            </el-form-item>
            <el-form-item prop="email" ref="email">
                <div slot="label" class="form-item-label" v-t="'message.item_tenant_email'"></div>
                <el-input id="email" size="large" type="text"
                          v-model="inputForm.email.value" :placeholder="$t('message.item_email_sample')"
                          @compositionstart.native="compositionStart($event.target.id)" @compositionend.native="compositionEnd($event.target.id)" @input.native="inputCheck($event.target.id)"
                          clearable @clear="inputCheckAll()"/>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import commonUtil from './commonutil.js';
import commonValidate from './common-validate.js';

export default {
    data () {
        return {
            formLabelWidth: "220px",
            smScreen: false,
            validationStatus: false,
            inputForm: {
                companyName:    { validationRule: "reqDisplayName", valid: false, value: null,	isComposing: false, forPaidOnly: false },
                companyNameKana:{ validationRule: "reqFullKana",    valid: false, value: null,	isComposing: false, forPaidOnly: true },
                departmentName: { validationRule: "displayName",    valid: true,  value: null,	isComposing: false, forPaidOnly: false },
                employees:      { validationRule: "numeric",        valid: false, value: null,	isComposing: false, forPaidOnly: true },
                zip:            { validationRule: "zip",            valid: false, value: null,	isComposing: false, forPaidOnly: false },
                pref:           { validationRule: "addressPref",    valid: false, value: null,	isComposing: false, forPaidOnly: false },
                city:           { validationRule: "address1",       valid: false, value: null,	isComposing: false, forPaidOnly: false },
                town:           { validationRule: "address1",       valid: false, value: null,	isComposing: false, forPaidOnly: false },
                street:         { validationRule: "address2",       valid: false, value: null,	isComposing: false, forPaidOnly: false },
                representativeLastName:  { validationRule: "reqDisplayName", valid: false, value: null,	isComposing: false, forPaidOnly: true },
                representativeFirstName: { validationRule: "reqDisplayName", valid: false, value: null,	isComposing: false, forPaidOnly: true },
                representativeLastNameKana: { validationRule: "reqFullKana", valid: false, value: null,	isComposing: false, forPaidOnly: true },
                representativeFirstNameKana:{ validationRule: "reqFullKana", valid: false, value: null,	isComposing: false, forPaidOnly: true },
                clerkLastName:  { validationRule: "reqDisplayName", valid: false, value: null,	isComposing: false, forPaidOnly: false },
                clerkFirstName: { validationRule: "reqDisplayName", valid: false, value: null,	isComposing: false, forPaidOnly: false },
                clerkLastNameKana: { validationRule: "reqFullKana", valid: false, value: null,	isComposing: false, forPaidOnly: true },
                clerkFirstNameKana:{ validationRule: "reqFullKana", valid: false, value: null,	isComposing: false, forPaidOnly: true },
                phoneNumber1:   { validationRule: "numeric",        valid: false, value: null,	isComposing: false, forPaidOnly: false },
                phoneNumber2:   { validationRule: "numeric",        valid: false, value: null,	isComposing: false, forPaidOnly: false },
                phoneNumber3:   { validationRule: "numeric",        valid: false, value: null,	isComposing: false, forPaidOnly: false },
                email:          { validationRule: "emailAddress",   valid: false, value: null,	isComposing: false, forPaidOnly: false },
            },
        };
    },
    methods: {
        compositionStart(eventTargetId) {
            this.inputForm[eventTargetId].isComposing = true;
        },
        compositionEnd(eventTargetId) {
            this.inputForm[eventTargetId].isComposing = false;
            this.inputCheck(eventTargetId)
        },
        handleChangePref() {
            this.inputForm["pref"].valid = true;
            this.$refs["pref"].clearValidate();
            this.setValidationStatus();
        },
        inputCheck(eventTargetId) {
            if (this.inputForm[eventTargetId].isComposing) {
                // inputting with IME
                return;
            }
            let validateResult;
            validateResult = commonValidate.validateItem(this.$i18n, this.inputForm[eventTargetId].validationRule, this.inputForm[eventTargetId].value);
            if ((eventTargetId === "phoneNumber1") || (eventTargetId === "phoneNumber2") || (eventTargetId === "phoneNumber3")) {
                if (this.inputForm[eventTargetId].value.length > 4) {
                    validateResult.valid = false;
                }
                if (validateResult.valid) {
                    this.inputForm[eventTargetId].valid = true;
                } else {
                    this.inputForm[eventTargetId].valid = false;
                }
                if (((this.inputForm.phoneNumber1.valid) && (this.inputForm.phoneNumber2.valid) && (this.inputForm.phoneNumber3.valid)) &&
                    ((this.inputForm.phoneNumber1.value.length + this.inputForm.phoneNumber2.value.length + this.inputForm.phoneNumber3.value.length) < 12) ) {
                    this.$refs["phoneNumber"].clearValidate();
                } else {
                    this.$refs["phoneNumber"].validateState = "error";
                    this.$refs["phoneNumber"].validateMessage = commonUtil.getMessageText(this.$i18n,"error_invalid_PhoneNumber_mobile_JPN");
                }
            } else {
                if (validateResult.valid) {
                    this.inputForm[eventTargetId].valid = true;
                    this.$refs[eventTargetId].clearValidate();
                } else {
                    this.inputForm[eventTargetId].valid = false;
                    this.$refs[eventTargetId].validateState = "error";
                    this.$refs[eventTargetId].validateMessage = validateResult.message;
                }
            }
            this.setValidationStatus();
        },
        inputCheckAll() {
            for (let targetId in this.inputForm) {
                this.inputCheck(targetId);
            }
        },
        setValidationStatus() {
            let oldValidationStatus = this.validationStatus;
            if (commonValidate.checkFormValidation(this.inputForm)) {
                this.validationStatus = true;
            } else {
                this.validationStatus = false;
            }
        },
    },
    created: function() {
        if (commonUtil.isSmartPhoneScreen()) {
            this.smScreen = true;
            this.formLabelWidth = "";
        }
        let externalScript = document.createElement('script')
        externalScript.setAttribute('src', '../js/yubinbango-core.js')
        document.head.appendChild(externalScript)
        this.prefList = commonUtil.getPrefList();
        if (this.paidInformation !== null) {
            this.inputForm = this.paidInformation;
        }
    },
    mounted: function() {
    },
    watch: {
        'inputForm.zip.value': function(zip) {
            let self = this
            if (zip.length < 7) {
                self.inputForm.pref.value = "";
                self.inputForm.city.value = "";
                self.inputForm.town.value = "";
                self.inputForm.street.value = "";
                self.inputCheck("pref");
                self.inputCheck("city");
                self.inputCheck("town");
                self.inputCheck("street");
                return;
            }
            new YubinBango.Core(zip, function(addr) {
                self.inputForm.pref.value = addr.pref;
                self.inputForm.city.value = addr.city
                self.inputForm.town.value = addr.town
                if (addr.street !== "") {
                    self.inputForm.street.value = addr.street
                }

                self.inputCheck("pref");
                self.inputCheck("city");
                self.inputCheck("town");
                self.inputCheck("street");
            })
        },
    },
    computed: {
        isJapanese() {
            return (this.$i18n.locale == 'ja')
        }
    },
    props: [ 'paidInformation' ]
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
